import BaseParseObject from './BaseParseObject'

'use strict'

const AstrobinImageOfTheDay = BaseParseObject.extend(
    'AstrobinImageOfTheDay',
    {
      licenseData: {
        ALL_RIGHTS_RESERVED: { name: 'All rights reserved', image: 'c.png' },
        ATTRIBUTION_NON_COMMERCIAL_SHARE_ALIKE: {
          name: 'Attribution-NonCommercial-ShareAlike Creative Commons',
          image: 'cc-by-nc-sa.png'
        },
        ATTRIBUTION_NON_COMMERCIAL: {
          name: 'Attribution-NonCommercial Creative Commons',
          image: 'cc-by-nc.png'
        },
        ATTRIBUTION_NON_COMMERCIAL_NO_DERIVS: {
          name: 'Attribution-NonCommercial-NoDerivs Creative Commons',
          image: 'cc-by-nc-nd.png'
        },
        ATTRIBUTION: { name: 'Attribution Creative Commons', image: 'cc-by.png' },
        ATTRIBUTION_SHARE_ALIKE: {
          name: 'Attribution-ShareAlike Creative Commons',
          image: 'cc-by-sa.png'
        },
        ATTRIBUTION_NO_DERIVS: {
          name: 'Attribution-NoDerivs Creative Commons',
          image: 'cc-by-nd.png'
        }
      }
    }
  )

export default AstrobinImageOfTheDay
